export class ParamValue {

    /**
     * @type string
     */
    value;
    /**
     * @type Number[]
     */
    variants;

    /**
     *
     * @param value {String}
     * @param variants {Number[]}
     */
    constructor(value, variants) {
        this.value = value;
        this.variants = variants;
    }

}